var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.disabled)?_c('div',{staticClass:"loading-wrap d-flex justify-content-center",class:( _obj = { 'global-loader': _vm.globalLoader }, _obj[("theme-" + _vm.theme)] = _vm.isTheme, _obj )},[_c('div',{staticClass:"loading-indicator-wrap",class:[_vm.smallLoader ? 'small-size' : 'default-size']},[_c('div',{staticClass:"loading-indicator"})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }